import moment from 'moment';

export const formatFriendlyDate = date => {
  return moment(formatDateWithSlashes(date)).format('ddd D MMM')
};

export const currentMonth = () => moment().format('MMMM')

export const nextNMonths = (n = 6) => {
  const currMonthIndex = moment().month()
  let months = []
  for (let i = 0; i < n; i++) {
    months.push(
      moment()
        .month(i + currMonthIndex)
        .format('MMMM')
    )
  }
  return months
};

export const getMonthString = date =>
  moment(formatDateWithSlashes(date)).format('MMMM')

export const formatDateWithSlashes = date => {
  if (date.includes('/')) {
    let arr = date.split('/')
    date = arr[2] + arr[1] + arr[0]
  }
  return date
};

const monthAsString = m =>
  moment()
    .month(m)
    .format('MMMM')

export const getMonthsBetweenDates = (start, end, limit) => {
  const startMonth = moment(formatDateWithSlashes(start)).month()
  let endMonth = moment(formatDateWithSlashes(end)).month()
  limit += startMonth
  let months = []
  endMonth++
  for (let i = startMonth; i < endMonth; i++) {
    months.push(monthAsString(i))
  }
  return months
};

export const sortMonths = months => {
  return months.sort((a, b) => {
    return moment()
      .month(a)
      .isBefore(moment().month(b))
      ? -1
      : 1
  })
};

export const hasDatePassed = date => {
  return moment(formatDateWithSlashes(date)).isBefore(moment())
};



// WEBPACK FOOTER //
// ./src/utils/dateParser.js